import { createContext, useContext, useState, useEffect } from 'react';

const CursorContext = createContext();

export const CursorProvider = ({ children }) => {
  const [cursor, setCursor] = useState('auto');

  // Reset cursor when the component mounts (page refresh)
  useEffect(() => {
    setCursor('auto');
  }, []);

  return (
    <CursorContext.Provider value={{ cursor, setCursor }}>
      {children}
    </CursorContext.Provider>
  );
};

export const useCursor = () => useContext(CursorContext);